import axios from 'axios'
import showToastify from '../utils/toastify'
import "toastify-js/src/toastify.css"
import { find } from 'utils/dom'

export default function contatoForm() {
	const page = find("[js-page='contato']");
	if (!page) return;

	const btnSubmit = document.querySelector('.contact-form-3 button[type=submit]');
	const contatoFormSubmit = document.querySelector('.contact-form-3');

	function disabledBtn() {
		btnSubmit.disabled = true;
		btnSubmit.classList.add('disabled');
	}

	function enabledBtn() {
		btnSubmit.disabled = false;
		btnSubmit.classList.remove('disabled');
	}

	function showMessage(response) {
		const message = response.data ? response.data.message : response.message;
		showToastify(message);
		contatoFormSubmit.reset();
		setTimeout(enabledBtn, 1000);
	}

	/** Validação de e-mail */
	function IsEmail(email) {
		const regex = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
		return regex.test(email);
	}

	if (contatoFormSubmit) {
		contatoFormSubmit.addEventListener('submit', async function (event) {
			event.preventDefault();
			disabledBtn();

			const nome = document.querySelector('.contact-form-3 .form-group input[name=nome]').value;
			const email = document.querySelector('.contact-form-3 .form-group input[name=email]').value;

			const inputs = document.querySelectorAll('.contact-form-3 .form-group input[name=texto_deseja_receber]');
			const inputCheckds = [];
			inputs.forEach(input => {
				if (input.checked) inputCheckds.push(input.value);
			});

			const EmailErro = document.querySelector('.mailing-email-error');
			const NomeErro = document.querySelector('.mailing-nome-error');

			EmailErro.innerText = "";
			NomeErro.innerText = "";

			let Erros = 0;

			if (email === '') {
				EmailErro.innerText = "Favor preencher os campos obrigatórios.";
				Erros++;
			} else if (!IsEmail(email)) {
				EmailErro.innerText = "Favor insira um email válido";
				Erros++;
			}

			if (nome === '') {
				NomeErro.innerText = "Favor preencher os campos obrigatórios.";
				Erros++;
			}

			if (Erros > 0) {
				enabledBtn();
				return;
			}

			if (!window.grecaptcha || !window.site_key) {
				console.error('reCAPTCHA não carregado ou site_key ausente.');
				enabledBtn();
				return;
			}

			try {
				const token = await grecaptcha.execute(window.site_key, { action: 'submit' });

				const formData = new FormData();
				formData.append('nome', nome);
				formData.append('email', email);
				formData.append('texto_deseja_receber', inputCheckds);
				formData.append('recaptcha_token', token);

				const url = '/mailing/';
				axios
					.post(url, formData)
					.then((response) => showMessage(response))
					.catch((response) => showMessage(response));
			} catch (err) {
				console.error('Erro ao executar o reCAPTCHA:', err);
				enabledBtn();
				showToastify('Erro de segurança ao enviar. Tente novamente.');
			}
		});
	}
}
